import { List, Project } from "src/app/models";

/**
 * Generate the text title of a new list page.
 */
export const getListTitle = (
  project?: Project.Project,
  list?: List.List
): string => {
  let title = "";

  if (!project || !list) return "";

  switch (project.type) {
    case 0:
      list.unit != "" ? (title = `${list.unit}`) : (title = "List");
      break;
    case 1:
      if (list.address) title = list.address;
      if (title != "" && list.unit) {
        title += `, ${list.unit}`;
      } else if (title == "" && list.unit) {
        title += `${list.unit}`;
      } else if (title == "") {
        title = "List";
      }
      break;
    case 2:
      if (list.unit) title = list.unit;
      break;
    case 3:
      if (list.unit) title = list.unit;
      break;
  }
  return title;
};
